var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  width: 100%;\n  justify-content: space-between;\n  text-transform: uppercase;\n'], ['\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  width: 100%;\n  justify-content: space-between;\n  text-transform: uppercase;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n'], ['\n  display: flex;\n  align-items: center;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  display: flex;\n  ', ';\n  flex-direction: ', ';\n  word-wrap: break-word;\n  flex-wrap: wrap;\n  justify-content: space-between;\n\n  @media(max-width: 1199px) {\n    flex: 1;\n    flex-basis: 100%;\n  }\n'], ['\n  position: relative;\n  display: flex;\n  ', ';\n  flex-direction: ', ';\n  word-wrap: break-word;\n  flex-wrap: wrap;\n  justify-content: space-between;\n\n  @media(max-width: 1199px) {\n    flex: 1;\n    flex-basis: 100%;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex: 1;\n  flex-direction: ', ';\n  position: relative;\n  word-wrap: break-word;\n  flex-wrap: wrap;\n  background-color: #fff;\n  min-width: 375px;\n'], ['\n  display: flex;\n  flex: 1;\n  flex-direction: ', ';\n  position: relative;\n  word-wrap: break-word;\n  flex-wrap: wrap;\n  background-color: #fff;\n  min-width: 375px;\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  ', ';\n  flex-direction: ', ';\n  position: relative;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  width: 100%;\n  height: ', ';\n  box-shadow: 0 5px 10px 0 rgba(0, 35, 75, 0.15);\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n  padding: ', ';\n'], ['\n  display: flex;\n  ', ';\n  flex-direction: ', ';\n  position: relative;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  width: 100%;\n  height: ', ';\n  box-shadow: 0 5px 10px 0 rgba(0, 35, 75, 0.15);\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n  padding: ', ';\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import styled from 'styled-components';
import PropTypes from 'prop-types';

var TitleBarDefinition = styled.div(_templateObject);
TitleBarDefinition.displayName = 'TitleBar';
export var TitleBar = TitleBarDefinition;

var TitleActionDefinition = styled.div(_templateObject2);
TitleActionDefinition.displayName = 'TitleAction';
export var TitleAction = TitleActionDefinition;

var TitleContentDefinition = styled.div(_templateObject3);
TitleContentDefinition.displayName = 'TitleContent';
export var TitleContent = TitleContentDefinition;

var SideDefinition = styled.div(_templateObject4, function (props) {
  return props.basis && 'flex-basis: ' + props.basis + '%';
}, function (props) {
  return props.vertical && 'column' || 'row';
});
SideDefinition.displayName = 'Side';
SideDefinition.propTypes = {
  basis: PropTypes.number,
  vertical: PropTypes.bool
};
export var Side = SideDefinition;

var PanelContentDefinition = styled.div(_templateObject5, function (props) {
  return props.vertical && 'column' || 'row';
});
PanelContentDefinition.displayName = 'PanelContent';
PanelContentDefinition.propTypes = {
  vertical: PropTypes.bool
};
export var PanelContent = PanelContentDefinition;

var PanelDefinition = styled.div(_templateObject6, function (props) {
  return props.basis && 'flex-basis: ' + props.basis + '%';
}, function (props) {
  return props.vertical && 'column' || 'row';
}, function (props) {
  return props.h && props.h + 'px' || 'auto';
}, function (props) {
  return '' + (props.noPadding ? 0 : '30px');
});
PanelDefinition.displayName = 'Panel';
PanelDefinition.propTypes = {
  basis: PropTypes.number,
  h: PropTypes.number,
  noPadding: PropTypes.bool,
  vertical: PropTypes.bool
};
export var Panel = PanelDefinition;